import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

function SideBar() {
  const { t } = useTranslation();
  const location = useLocation();
  const pathname = location.pathname;

  return (
    <aside id="sidebar" className="sidebar">
      <ul className="sidebar-nav" id="sidebar-nav">
        <li className="nav-item">
          <Link
            className={
              pathname === "/dashboard"
                ? "nav-link active"
                : "nav-link"
            }
            to="/dashboard"
          >
            <i className="bi bi-grid"></i>
            <span>{t('dashboard')}</span>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            className={
              pathname === "/users"
                ? "nav-link active"
                : "nav-link"
            }
            to="/users"
          >
            <i className="bi bi-people"></i>
            <span>{t('users')}</span>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            className={
              pathname === "/networks"
                ? "nav-link active"
                : "nav-link"
            }
            to="/networks"
          >
            <i className="bi bi-cloud-arrow-up"></i>
            <span>{t('networks')}</span>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            className={
              pathname === "/cryptocurrencies"
                ? "nav-link active"
                : "nav-link"
            }
            to="/cryptocurrencies"
          >
            <i className="bi bi-cloud-arrow-up"></i>
            <span>{t('cryptocurrencies')}</span>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            className={
              pathname === "/swap"
                ? "nav-link active"
                : "nav-link"
            }
            to="/swap"
          >
            <i className="bi bi-cloud-arrow-up"></i>
            <span>{t('swap')}</span>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            className={
              pathname === "/reward-settings"
                ? "nav-link active"
                : "nav-link"
            }
            to="/reward-settings"
          >
            <i className="bi bi-cloud-arrow-up"></i>
            <span>{t('reward_settings')}</span>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            className={
              pathname === "/reward-transactions"
                ? "nav-link active"
                : "nav-link"
            }
            to="/reward-transactions"
          >
            <i className="bi bi-list-ul"></i>
            <span>{t('reward_transactions')}</span>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            className={
              pathname === "/staking-plans"
                ? "nav-link active"
                : "nav-link"
            }
            to="/staking-plans"
          >
            <i className="bi bi-layers"></i>
            <span>{t('staking_plans')}</span>
          </Link>
        </li>

        <li className="nav-item">
          <Link
            className={
              pathname.startsWith("/user-staking")
                ? "nav-link active"
                : "nav-link"
            }
            to="/user-staking"
          >
            <i className="bi bi-wallet2"></i>
            <span>{t('user_staking_list') || 'User Staking List'}</span>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            className={
              pathname.startsWith("/user-etoken-balances")
                ? "nav-link active"
                : "nav-link"
            }
            to="/user-etoken-balances"
          >
            <i className="bi bi-wallet2"></i>
            <span>{t('staking_etoken_balance') || 'Staking Etoken Balance'}</span>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            className={
              pathname.startsWith("/user-watch-points")
                ? "nav-link active"
                : "nav-link"
            }
            to="/user-watch-points"
          >
            <i className="bi bi-play-circle"></i>
            <span>{t('user_watch_points_history') || 'User Watch Points History'}</span>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            className={
              pathname.startsWith("/user-daily-bonus")
                ? "nav-link active"
                : "nav-link"
            }
            to="/user-daily-bonus"
          >
            <i className="bi bi-gift"></i>
            <span>{t('user_daily_bonus_history') || 'User Daily Bonus History'}</span>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            className={
              pathname.startsWith("/admob-settings")
                ? "nav-link active"
                : "nav-link"
            }
            to="/admob-settings"
          >
            <i className="bi bi-gear"></i>
            <span>{t('admob_setting') || 'AdMob Setting'}</span>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            className={
              pathname.startsWith("/admob-points-settings")
                ? "nav-link active"
                : "nav-link"
            }
            to="/admob-points-settings"
          >
            <i className="bi bi-gear"></i>
            <span>{t('admob_points_setting') || 'AdMob Points Setting'}</span>
          </Link>
        </li>
      </ul>
    </aside>
  );
}

export default SideBar;
